import React, { useState, useEffect, useRef } from 'react';
import { Form, Button, Modal, Col, Row, Tab, Tabs, Alert } from 'react-bootstrap';
import { FaRegTrashAlt } from "react-icons/fa";
import { RiAddBoxLine } from "react-icons/ri";
import TemplateCrudService from '../../services/TemplateCrudService';
import InputText from '../../components/Forms/InputText'

export default function ModalTemplate({ show, handleClose, dataItem, setRenderRows }) {

  const NERTHUS = process.env.REACT_APP_NERTHUS_API_URL + '/images';
  const conditionView = (dataItem.typeView === 'View' || dataItem.typeView === 'Delete') ? true : false;

  const newFeatureRef = useRef(null);
  const newRecommendRef = useRef(null);

  const [urlDemo, setUrlDemo] = useState('');
  const [features, setFeatures] = useState([]);
  const [tempImages, setTempImages] = useState({});
  const [templateName, setTemplateName] = useState('');
  const [templateFile, setTemplateFile] = useState('');
  const [tempDescription, setTempDescription] = useState('');
  const [templateCreator, setTemplateCreator] = useState('');
  const [templatePriority, setTemplatePriority] = useState('');
  const [recommendations, setRecommendations] = useState([]);
  const [templateversion, setTemplateVersion] = useState(null);

  const [successSend, setSuccessend] = useState(null);
  const [selectedImages, setSelectedImages] = useState({});
  const [enableSaveChanges, setEnableSaveChanges] = useState(true);
  const [enableChangeImage, setEnableChangeImage] = useState(true);
  const [disableBottonClose, setDisableBottonClose] = useState(false);

  useEffect(() => {
    if (show && dataItem.codeItem > 0) {

      TemplateCrudService.getTemplateById(dataItem.codeItem).then(async res => {

        let currentTemplate = res.data.data[0];

        setTemplateName(currentTemplate.name);
        setTemplateFile(currentTemplate.file);
        setTempDescription(currentTemplate.description);
        setTempImages(currentTemplate.images);
        setRecommendations(currentTemplate.recommendations);
        setFeatures(currentTemplate.features);
        setUrlDemo(currentTemplate.urlDemo);
        setTemplateCreator(currentTemplate.creator);
        setTemplatePriority(currentTemplate.priority);
        setTemplateVersion(currentTemplate.version);

      });
    } else {

      setTemplateName('');
      setTemplateFile('');
      setTempDescription('');
      setTempImages({});
      setRecommendations([]);
      setFeatures([]);
      setUrlDemo('');
      setTemplateCreator('');
      setTemplatePriority('');
      setTemplateVersion(null);
      setEnableSaveChanges(true);
      setSuccessend(null);
      setEnableChangeImage(true);
      setSelectedImages({});

    }
  }, [dataItem, show]);

  const handlerTemplateNameChange = (event) => {
    setTemplateName(event.target.value);
    setEnableSaveChanges(false);
  }

  const handlerUrlDemoChange = (event) => {
    setUrlDemo(event.target.value);
    setEnableSaveChanges(false);
  }

  const handlerTemplateVersionChange = (event) => {
    setTemplateVersion(event.target.value);
    setEnableSaveChanges(false);
  }

  const handlerTemplateCreatorChange = (event) => {
    setTemplateCreator(event.target.value);
    setEnableSaveChanges(false);
  }

  const handlerTemplatePriorityChange = (event) => {
    setTemplatePriority(event.target.value);
    setEnableSaveChanges(false);
  }

  const handlerTemplateFileChange = (event) => {
    setTemplateFile(event.target.value);
    setEnableSaveChanges(false);
  }

  const handlerTempDescriptionChange = (event) => {
    setTempDescription(event.target.value);
    setEnableSaveChanges(false);
  }

  const setAddNewFeature = () => {
    if (newFeatureRef.current.value) {
      let newFeature = newFeatureRef.current.value;
      setFeatures(features => [...features, newFeature]);
      setEnableSaveChanges(false);
      newFeatureRef.current.value = '';
    }
  }

  const setAddNewRecommend = () => {
    if (newRecommendRef.current.value) {
      let newRecommend = newRecommendRef.current.value;
      setRecommendations(recommendations => [...recommendations, newRecommend]);
      setEnableSaveChanges(false);
      newRecommendRef.current.value = '';
    }
  }

  const DeleteFeature = (indexItem) => {
    setFeatures((prevState) =>
      prevState.filter((todo, index) => index !== indexItem)
    );
    setEnableSaveChanges(false);
  };

  const DeleteRecommend = (indexItem) => {
    setRecommendations((prevState) =>
      prevState.filter((todo, index) => index !== indexItem)
    );
    setEnableSaveChanges(false);
  };

  const DeleteImage = (index) => {

    alert('!Se ha Eliminado¡ ' + index);
    const image = selectedImages[index];
    if (image) {
      delete selectedImages[index];
      setSelectedImages({ ...selectedImages });
    }

    setTempImages(prevState => ({
      ...prevState,
      [index]: '/default/default.jpg'
    }));
    setEnableChangeImage(false);

  };

  function handleFileChange(event) {

    let realName = {
      image: 'thumb.jpg',
      imageDesktop: 'thumb_desktop.jpg',
      imageTablet: 'thumb_tablet.jpg',
      imageMobile: 'thumb_mobile.jpg'
    }

    const { name } = event.target;
    let file = event.target.files[0];
    let newFile = new File([file], realName[name], { type: file.type });
    setSelectedImages({ ...selectedImages, [name]: newFile });
    setEnableChangeImage(false);
  }

  function renderImagePreview(name, defaultValue) {
    const image = selectedImages[name];
    return image ? <img src={URL.createObjectURL(image)} alt={image.name} style={{ width: '500px' }} /> : <img src={defaultValue} alt={name} style={{ width: '500px' }} />;
  }

  function sleep(time) {
    return new Promise((resolve) => setTimeout(resolve, time))
  }

  const handleSubmit = async () => {

    let updateTemplate = {
      name: templateName,
      description: tempDescription,
      urlDemo: urlDemo,
      file: templateFile,
      creator: templateCreator,
      priority: templatePriority,
      version: templateversion,
      features: features,
      recommendations: recommendations
    };

    TemplateCrudService.updateTemplate(updateTemplate, dataItem.codeItem).then(res => {

      setSuccessend('success');
      sleep(1500).then(() => {
        handleClose();
        window.location.href = '/templates';
      })
    }).catch(err => {
      console.log(err);
      if (err.response.status !== 200) {
        setSuccessend('danger');
      }
    });
  };

  const handleDelete = async () => {
    TemplateCrudService.deleteTemplate(dataItem.codeItem).then(res => {
      setSuccessend('success');
      sleep(1500).then(() => {
        handleClose();
        window.location.href = '/templates';
      })
    }).catch(err => {
      console.log(err);
      if (err.response.status !== 200) {
        setSuccessend('danger');
      }
    });
  };

  const handleImageSubmit = async () => {

    const formData = new FormData();
    let realName = {
      image: '/templates/' + dataItem.codeItem + '/thumb.jpg',
      imageDesktop: '/templates/' + dataItem.codeItem + '/thumb_desktop.jpg',
      imageTablet: '/templates/' + dataItem.codeItem + '/thumb_tablet.jpg',
      imageMobile: '/templates/' + dataItem.codeItem + '/thumb_mobile.jpg'
    }

    Object.keys(selectedImages).forEach((name) => {
      formData.append('files[]', selectedImages[name]);
      tempImages[name] = realName[name];
    });
    formData.append('images', JSON.stringify(tempImages));

    TemplateCrudService.uploadImagesTemplate(dataItem.codeItem, formData).then(res => {
      setSuccessend('success');
      setEnableSaveChanges(true);
      sleep(1000).then(() => {
        handleClose();
        window.location.href = '/templates';
      })
    }).catch(err => {
      console.log(err);
      if (err.response.status !== 200) {
        setSuccessend('danger');
      }
    });
  };

  let addSubmitButton = "";
  if (!conditionView) {
    addSubmitButton = (<><Button type="button" disabled={enableSaveChanges} onClick={() => handleSubmit()} >Save Changes</Button> {'  '}  {'  '}  </>);
  }
  if (dataItem.typeView === 'Delete') {
    addSubmitButton = (<><Button type="button" variant="danger" onClick={() => handleDelete()} >Delete</Button> {'  '}  {'  '} </>);
  }

  const setCloseButton = <><Button variant="secondary" disabled={disableBottonClose} onClick={handleClose}> Close </Button> </>;

  return (<>
    <Modal size="lg" show={show} onHide={handleClose} backdrop="static"
				aria-labelledby="contained-modal-title-vcenter"
				dialogClassName="custom-modal-dialog"
    >
      <Modal.Header closeButton>
        <Modal.Title> {dataItem.typeView} {dataItem.nameView} Code {dataItem.codeItem} </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {(dataItem.typeView === 'Delete') ? (<Alert key='danger' variant='danger'> ¿Seguro que quieres Eliminar el Template? </Alert>) : ""}
        <Tabs defaultActiveKey="main" id="justify-tab-example" className="mb-3" justify>

          <Tab eventKey="main" title="Data Template">
            <Row className="mb-3">
              <InputText defaultValue={templateName} label={'Name'} handler={handlerTemplateNameChange} conditionView={conditionView} width={'3'} />
              <InputText defaultValue={urlDemo} label={'Url Demo'} handler={handlerUrlDemoChange} conditionView={conditionView} width={'5'} />
              <InputText defaultValue={templateversion} label={'Version'} handler={handlerTemplateVersionChange} conditionView={conditionView} width={'2'} />
              <InputText defaultValue={templatePriority} label={'Priority'} handler={handlerTemplatePriorityChange} conditionView={conditionView} width={'2'} />
            </Row>

            <Row className="mb-3">
              <InputText defaultValue={templateFile} label={'Template File'} handler={handlerTemplateFileChange} conditionView={conditionView} width={'3'} />
              <InputText defaultValue={tempDescription} label={'Description'} handler={handlerTempDescriptionChange} conditionView={conditionView} width={'7'} />
              <InputText defaultValue={templateCreator} label={'Creator'} handler={handlerTemplateCreatorChange} conditionView={conditionView} width={'2'} />
            </Row>

            <hr></hr>
            {addSubmitButton}
            {setCloseButton}
          </Tab>

          <Tab eventKey="recommendations" title="Recommendations">

            <Row className="mb-3">
              {recommendations.map((itemRole, index) => {
                return ((<Form.Group as={Col} md="8" key={index}>
                  <Form.Label><FaRegTrashAlt type='button' alt='Eliminar' onClick={() => DeleteRecommend(index)} /> - {itemRole}</Form.Label>
                </Form.Group>))
              })}
            </Row>
            <Row className="mb-3">

              {!conditionView ? (<>
                <Form.Group as={Col} md="4" controlId="controlId8">
                  <Form.Control ref={newRecommendRef} type="text" placeholder="New Recommend" />
                </Form.Group>

                <Form.Group as={Col} md="4" controlId="controlId9">
                  <Button type="button" onClick={() => setAddNewRecommend()} > <RiAddBoxLine /> </Button>
                </Form.Group></>) : ('')}
            </Row>

            <hr></hr>
            {addSubmitButton}
            {setCloseButton}
          </Tab>

          <Tab eventKey="features" title="Features">
            <Row className="mb-3">
              {features.map((itemRole, index) => {
                return ((<Form.Group as={Col} md="8" key={index}>
                  <Form.Label> <FaRegTrashAlt type='button' alt='Eliminar' onClick={() => DeleteFeature(index)} /> - {itemRole}</Form.Label>
                </Form.Group>))
              })}
            </Row>
            <Row className="mb-3">
              {!conditionView ? (<>
                <Form.Group as={Col} md="4" controlId="controlId11">
                  <Form.Control ref={newFeatureRef} type="text" placeholder="New Feature" />
                </Form.Group>

                <Form.Group as={Col} md="4" controlId="controlId12">
                  <Button type="button" onClick={() => setAddNewFeature()} > <RiAddBoxLine /> </Button>
                </Form.Group></>) : ('')}
            </Row>

            <hr></hr>
            {addSubmitButton}
            {setCloseButton}
          </Tab>

          <Tab eventKey="images" title="images">
          <div style={{ maxHeight: '70vh', overflowY: 'auto', marginBottom: '20px' }}>
            {Object.entries(tempImages).map(([key, value]) => {
              return (<div key={key}>
                <Row className="mb-3" key={key}>
                  <Form.Group as={Col} md="6" key={key} controlId={key}>
                    {!conditionView ? (<>
                      <Form.Label>Cambiar {key}</Form.Label>
                      <Form.Control
                        type="file"
                        accept="image/png,image/jpeg"
                        name={key}
                        placeholder="Select Image File"
                        onChange={conditionView ? null : handleFileChange}
                        readOnly={conditionView ? true : false}
                        disabled={conditionView ? true : false}
                      />
                    </>) : ('')}
                  </Form.Group>
                </Row>
                <Row className="mb-3" key={key + value}>
                  <Form.Group as={Col} md="6" key={key + value} controlId={key + value}>
                    {renderImagePreview(key, NERTHUS + value)}

                    {!conditionView ? (<><span type='button' onClick={() => DeleteImage(key)}> <FaRegTrashAlt alt='Eliminar' /> Delete {key} </span></>) : ('')}
                  </Form.Group>
                </Row>
              </div>);
            })}
          </div>

            <hr></hr>
            {!conditionView ? (<><Button type="button" disabled={enableChangeImage} onClick={() => handleImageSubmit()}> Save Images </Button></>) : ('')}
            {'  '}  {'  '} {setCloseButton}
          </Tab>

        </Tabs>
        {(successSend == 'danger') ? (<Alert key='danger' variant='danger'> ¡Template no Update!</Alert>)
          : (successSend == 'success') ? (<Alert key='success' variant='success'> ¡Template Update! </Alert>) : ""}
      </Modal.Body>
    </Modal>
  </>)
}